import React from 'react';

import { Button, Grid, Stack } from '@mui/material';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { UseFormReturn, useForm } from 'react-hook-form';

import { ShuttleFilters } from '../../../../domain/shuttle';
import { ShuttleFiltersFormComponents } from './shuttle-filters-form-components';

// ********************************************************************************
// First step to shuttle reservation, the user must select the travel type,
// origin, destination, dates and number of passengers; the user can then
// proceed to select a trip. The form fields are displayed depending on the
// layout prop.
// The logic behind the form is handled by ShuttleFiltersFormComponents to
// decouple the logic from the rendering.
// SEE: shuttle-filter-form-components.tsx
type Props = {
  formManager: UseFormReturn<ShuttleFilters>;
  onSubmit: (values: ShuttleFilters) => void;
  layout: 'default' | 'accordion';
};

export const ShuttleFilterForm = ({ formManager, onSubmit, layout = 'default' }: Props) => {
  const { t } = useTranslation();
  // == Render ====================================================================
  const { travelTypeField, originField, destinationField, travelDateSelectField, passengerField } =
    ShuttleFiltersFormComponents(formManager);

  return (
    <Stack gap={3}>
      {travelTypeField}
      {layout === 'default' ? (
        <Grid container spacing={2.5}>
          <Grid item xs={12} md={6}>
            {originField}
          </Grid>
          <Grid item xs={12} md={6}>
            {destinationField}
          </Grid>
          <Grid item xs={12}>
            {travelDateSelectField}
          </Grid>
          <Grid item xs={12} md={6}>
            {passengerField}
          </Grid>
        </Grid>
      ) : (
        <Grid container spacing={2.5}>
          <Grid item xs={12} md={4}>
            {originField}
          </Grid>
          <Grid item xs={12} md={4}>
            {destinationField}
          </Grid>
          <Grid item xs={12} md={4}>
            {passengerField}
          </Grid>
          <Grid item xs={12} md={8}>
            {travelDateSelectField}
          </Grid>
        </Grid>
      )}
      <Stack alignItems="flex-end" height={44 /*placeholder*/}>
        <Button
          disabled={!formManager.formState.isValid}
          sx={{ width: 200 }}
          size="large"
          variant="contained"
          onClick={formManager.handleSubmit(onSubmit)}
        >
          {t('shuttle_service.search')}
        </Button>
      </Stack>
    </Stack>
  );
};
